import { render, staticRenderFns } from "./caseManagementDetail.vue?vue&type=template&id=bd319db8&scoped=true"
import script from "./caseManagementDetail.vue?vue&type=script&lang=js"
export * from "./caseManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./caseManagementDetail.vue?vue&type=style&index=0&id=bd319db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd319db8",
  null
  
)

export default component.exports